const initialState = {
  isLoading: false,
  totalRegistros: 0,
  totvsProduto: [],
  open: false,
  id: 0,
  codigo: '',
  descricao: '',
  idLoja: '',
  page: 0,
  limit: 10,
  order: 'nome',
  direction: 'asc',
  term: ''
}

export function totvsProduto(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_TOTVS_PRODUTO':
      return {
        ...state,
        totvsProduto: action.totvsProduto,
        totalRegistros: action.totalRegistros
      }
    case 'TOTVS_PRODUTO_DETAIL':
      return {
        ...state,
        isLoading: false,
        id: action.id,
        codigo: action.codigo,
        descricao: action.descricao,
        idLoja: action.idLoja
      }
    case 'TOTVS_PRODUTO_UPDATED':
      return state
    case 'TOTVS_PRODUTO_CLEAR':
      return {
        ...initialState,
        page: state.page,
        limit: state.limit,
        order: state.order,
        direction: state.direction,
        term: state.term
      }
    case 'TOTVS_PRODUTO_CLEAR_ALL':
      return {
        ...state,
        totvsProduto: []
      }
    case 'TOTVS_PRODUTO_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    case 'TOTVS_PRODUTO_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'TOTVS_PRODUTO_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
